export const EKYCURL = process.env.REACT_APP_EKYC_API;
export const UPLOADSIZELIMIT: number =
  process.env.REACT_APP_UPLOAD_SIZE_LIMIT !== undefined
    ? parseInt(process.env.REACT_APP_UPLOAD_SIZE_LIMIT)
    : 8;
export const UploadSizes = {
  passportPhoto: {
    pdfSize: 7.5,
    imageSize: 7.5,
  },
  pancard: {
    pdfSize: 7.5,
    imageSize: 7.5,
  },
  income_proof: {
    pdfSize: 7.5,
    imageSize: 7.5,
  },
  signature: {
    pdfSize: 7.5,
    imageSize: 7.5,
  },

  passport: {
    pdfSize: 7.5,
    imageSize: 7.5,
  },
  visa: {
    pdfSize: 7.5,
    imageSize: 7.5,
  },
  nominee: {
    pdfSize: 7.5,
    imageSize: 7.5,
  },
  bankproof: {
    pdfSize: 7.5,
    imageSize: 7.5,
  },
};
